export const COOKIE_HIDE_TMP_MSG_KEY = 'wineservices:hideTmpMessage';
export const COOKIE_VIEWED_ARTICLES = 'wineservices:articlesViewed:';
export const COOKIE_ARTICLES_FILTER_PAGE = 'wineservices:articlesPage:';
export const COOKIE_ARTICLES_FILTER_FILTERS = 'wineservices:articlesFilters:';
